export const ROUTES = {
    ROOT: "/",
    DASHBOARD: "/dashboard",
    POLICONSULTORIO: "/policonsultorio",
    SUCURSALES: "/sucursales",
    EME_COMERCIOS: "/eme-club/comercios",
    EME_BENEFICIOS: "/eme-club/beneficios",
    EME_BANNERS: "/eme-club/banners",
    EME_CANJES: "/eme-club/canjes",
    EME_INTERESES: "/eme-club/intereses",
    EME_PLANES: "/eme-club/planes",
    EME_NOTIFICACIONES: "/eme-club/notificaciones",
    COLABORADORES: "/colaboradores",
    ADMINISTRADORES: "/administradores",
    CONFIGURACION: "/configuracion",
    USUARIOS: "/usuarios",
    WEB_EME_BANNERS: "/sitio-web/eme-club/banners",
    WEB_EME_DATOS_INSTIT: "/sitio-web/eme-club/datos-instit",
};
